/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/PreviewBanner.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext } from 'react';
import { TranslationsContext, FormContext } from "@proxy/_contexts";
import { Banner } from "@proxy/_components";

const PreviewBanner = () => {

  const translations = useContext(TranslationsContext);
  const { fulfillmentType } = useContext(FormContext);
  
  return (
    <Banner status="notice">
      <h3>
        {translations.preview_heading}
      </h3>
      <p>
        {(fulfillmentType === "physical") ? translations.preview_info_physical : translations.preview_info}
      </p>
    </Banner>
  );
};

export default PreviewBanner;
